import { Navigate } from "react-router-dom";

// The old edit screen saved a fixed template id; editing now goes through the text and time steps.
function ChangeMessage() {
  return <Navigate to="/dashboard/profile/autoMessage" replace />;
}

export default ChangeMessage;
